import { createContext, useContext } from "react";
import { useInitialEvaluation } from "./useInitialEvaluation";
import type { SupplierEvaluationSummary } from "../types/scoring.type";

interface InitialEvaluationContextValue {
	suppliers: SupplierEvaluationSummary[];
	isLoading: boolean;
	error: string | null;
	allSuppliersScored: boolean;
	readOnly: boolean;
	notPermitted: boolean;
	refreshSupplier: (inviteId: number) => void;
}

const InitialEvaluationContext = createContext<InitialEvaluationContextValue | null>(null);

interface InitialEvaluationProviderProps {
	rfxId: number | undefined;
	children: React.ReactNode;
}

export const InitialEvaluationProvider: React.FC<InitialEvaluationProviderProps> = ({
	rfxId,
	children,
}) => {
	const value = useInitialEvaluation({ rfxId });

	return (
		<InitialEvaluationContext.Provider value={value}>
			{children}
		</InitialEvaluationContext.Provider>
	);
};

export const useInitialEvaluationContext = (): InitialEvaluationContextValue => {
	const context = useContext(InitialEvaluationContext);
	if (!context) {
		throw new Error("useInitialEvaluationContext must be used within an InitialEvaluationProvider");
	}
	return context;
};
